var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.accessBlockedMessage
        ? _c(
            "div",
            { staticClass: "access-blocked-banner", attrs: { role: "alert" } },
            [
              _c("span", { staticClass: "access-blocked-icon" }, [_vm._v("⚠")]),
              _vm._v(" " + _vm._s(_vm.accessBlockedMessage) + " "),
            ]
          )
        : _vm._e(),
      _c(
        "div",
        { staticClass: "subjectContainer" },
        [
          _c("p", { attrs: { tabindex: "0", "aria-live": "assertive" } }, [
            _vm._v(
              " " +
                _vm._s(
                  _vm.$gettext(
                    "Para obtener una atención personalizada, selecciona el tema de su consulta:"
                  )
                ) +
                " "
            ),
          ]),
          _vm._l(_vm.allChatOptions, function (type, index) {
            return _c("type-chat", {
              key: type.id,
              attrs: { index: index, type: type, url: _vm.url },
            })
          }),
        ],
        2
      ),
      _c("default-responses"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }